import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { List } from 'immutable';

import { formatExpiryTime } from '@xanadu/ui-shared/utils/dates';

import Placeholder from './components/Placeholder';

import styles from './ManualBonus.module.scss';

const ManualBonus = ({
  updateRightSidebar,
  getExchangeBonuses,
  bonuses,
  loading,
  error,
}) => {
  const closeRightSidebar = () => {
    updateRightSidebar({
      content: null,
      visible: false
    });
  };

  useEffect(() => {
    getExchangeBonuses();
  }, []);

  return (
    <div className={styles.manualBonus}>
      {!loading && error && (
        <div className={styles.error}>
          Free Bet Breakdown is not currently available
        </div>
      )}
      {loading && !error && <Placeholder />}
      {!loading && !error && (
        <div className={styles.activeBonuses}>
          {bonuses.map(bonus => {
            const {
              expiration,
              name,
              bonusTargetUrl,
              bonusTargetAbsoluteUrl,
              id,
              description,
              products
            } = bonus;

            const isPredictions = products.includes('PREDICTIONS');

            const expiry = formatExpiryTime(expiration);

            return (
              <div className={styles.bonusInfo} key={id}>
                <span className={styles.title}>{name}</span>
                <span className={styles.desc}>
                  {description}
                </span>
                <span className={styles.expiry}>{expiry}</span>
                {bonusTargetUrl && !isPredictions && (
                  <Link
                    className={styles.link}
                    onClick={closeRightSidebar}
                    to={bonusTargetUrl}
                  >Play Now
                  </Link>
                )}
                {bonusTargetAbsoluteUrl && isPredictions && (
                  <a
                    className={styles.link}
                    onClick={closeRightSidebar}
                    href={bonusTargetAbsoluteUrl}
                  >Play Now
                  </a>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div className={styles.terms}>
        <p>{'Free Bets are only eligible to be played on the designated sport or competition. If no sport or competition is specified, a Free Bet can be played on any exchange bet.'}</p>
        <p>{'In the case of a winning bet, the bet will be paid out, but the original stake will not be returned.'}</p>
        <p>{'Free Bets cannot be withdrawn. Bets placed using a Free Bet cannot be edited or cashed out.'}</p>
        <p>{'Once a Free Bet reaches its expiry date, it will be removed from your account and can no longer be used.'}</p>
        <p>When opting to use a Free Bet, the full value of the Free Bet amount will be wagered.</p>
        <Link
          className={styles.link}
          onClick={closeRightSidebar}
          to="/page/rules_and_regulations/standard-promo-terms-and-conditions/"
        >Check our full Free Bet T&Cs</Link>
      </div>
    </div>
  );
};

ManualBonus.propTypes = {
  updateRightSidebar: PropTypes.func.isRequired,
  getExchangeBonuses: PropTypes.func.isRequired,
  bonuses: PropTypes.instanceOf(List),
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
};

export default ManualBonus;
